export const state_child = {
		"in-kindergarten": "Дитина в садочку",
		"in-school": "Дитина вибула до школи",
		"out-of-scope": "Дитина вибута"
		
}

export const statuses_types = [
    { action: "transfer-group-curperiod", translate: "Переведення в групу поточного навчального року"},
	{ action: "transfer-group-nextperiod", translate: "Переведення в групу наступного навчального року"},
	{ action:"temp-moved", translate: "Тимчасове переведення до іншого садочку"}
]
